import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {MatTabGroup} from '@angular/material/tabs';
import {ConsentsFormService} from '../../../services/consents-form.service';

import {Router} from '@angular/router';

@Component({
  selector: 'app-children-consents',
  templateUrl: './children-consents.component.html',
  styleUrls: ['./children-consents.component.scss']
})
export class ChildrenConsentsComponent implements OnInit {
  @ViewChild('tabs', {static: false}) tabs: MatTabGroup;
  @ViewChild('tabElement', {static: false}) matTab: ElementRef;
  @Input() children: any[];
  @Input() currentUser: any;
  @Input() notifications: any[];
  @Input() notificationTitle: string;
  selectChildIndex: any;
  childContentHtml: string;

  consents = [];
  groupsWidth: number;
  selectedIndex: any;
  tabFocus: any;

  constructor(public consentsFormService: ConsentsFormService,
              public router: Router) {
    this.groupsWidth = window.innerWidth - 10;
    this.selectedIndex = 0;
  }

  ngOnInit(): void {
    // console.log(this.children);
    this.selectChildIndex = this.children[0];
  }

  childrenDisplayName(child: any) {
    return `${child.firstName} ${child.lastName}`;
  }

  childNotification(child: any) {
    const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
    return filteredConsents.length + child.affirmations.length;
  }

  showNotificationToChild(child: any) {
    const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
    return filteredConsents.length === 0;
  }


  async showConsent(notification: any) {

    const child = this.children[this.tabs.selectedIndex];
    await this.consentsFormService.showConsent(notification, this.currentUser, child);
  }

  changeTab(event: any) {
    const tab = this.matTab;
    tab.nativeElement.autofocus = true;
    tab.nativeElement.focus();
  }

  change(childName) {
  }

  testFunc() {
    return this.consents;
  }

  buttonColor(mode: string) {
    if (mode === 'consent') {
      return 'green';
    } else {
      return '#013e81';
    }
  }


  getNotificationColor(child: any) {
    const hasNotification = this.childNotification(child) > 0;

    return hasNotification === true ? 'red' : 'gray';
  }

    async completeAffirmation(child: any, affirmation: any) {
        await this.router.navigate(['home/complete-affirmation'], {queryParams: {id: affirmation.id, child: child.id}});
    }

  async showAnnouncement(announcement: any) {
    await this.router.navigate(['home/announcement'], {queryParams: {id: announcement.id, unique_id: announcement.unique_id}});
  }
}
